"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { motion } from "motion/react";
import { cn } from "@/lib/util/cn";
export function Header() {
  const $ = _c(1);
  const path = usePathname();
  const isHome = path === "/";
  if (isHome) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><header className="absolute top-3 z-20 max-lg:inset-x-0"><nav className="w-fit rounded-2xl bg-neutral-100/30 px-3 py-1.5 ring-neutral-300/50 backdrop-blur-2xl max-lg:mx-auto dark:bg-neutral-800/50 dark:ring-neutral-700/50"><ul className="flex space-x-3"><li><NavLink href="/">Home</NavLink></li><li><NavLink href="/about">About</NavLink></li><li><NavLink href="/now">Now</NavLink></li><li><NavLink href="/heys">Heys</NavLink></li><li><NavLink href="/essays">Essays</NavLink></li></ul></nav></header></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function NavLink(t0) {
  const $ = _c(15);
  let children;
  let className;
  let onClick;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = onClick;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    onClick = $[3];
    props = $[4];
  }
  const path = usePathname();
  const current = path === props.href;
  let t1;
  if ($[5] !== className) {
    t1 = cn(className, "relative text-neutral-900/80 dark:text-neutral-100/80", "hover:text-neutral-950 dark:hover:text-neutral-50", "transition-colors duration-200");
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== current) {
    t2 = current && <motion.span layoutId="header-nav" className="absolute -bottom-[2px] left-0 h-[2px] w-full bg-neutral-950/30 dark:bg-neutral-50/30" />;
    $[7] = current;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== onClick || $[11] !== props || $[12] !== t1 || $[13] !== t2) {
    t3 = <Link {...props} onClick={onClick} className={t1}>{children}{t2}</Link>;
    $[9] = children;
    $[10] = onClick;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}